import { listFormTemplates } from '@wix/ambassador-forms-v1-form-template/http';
import { FORM_PLATFORM_NAMESPACE } from '../constants/namespaces';
import { ADDRESS_FORM_ID_BY_COUNTRY } from '@wix/form-multiline-address';
import { overrideTemplateFieldIds } from './address-forms-overrides';
const addressCountryToFormMap = Object.entries(ADDRESS_FORM_ID_BY_COUNTRY).map(([country, id]) => ({ country, id }));
export const fetchAddressForms = async (httpClient) => {
    const res = await httpClient.request(listFormTemplates({
        templateIds: [...new Set(Object.values(ADDRESS_FORM_ID_BY_COUNTRY))],
        namespace: FORM_PLATFORM_NAMESPACE,
    }));
    const templatesWithOverrides = res.data.templates && overrideTemplateFieldIds(res.data.templates);
    return addressCountryToFormMap
        .map((addressCountryToForm) => {
        return {
            ...addressCountryToForm,
            template: templatesWithOverrides?.find((_form) => _form.id === addressCountryToForm.id),
        };
    })
        .filter((addressCountryToForm) => Boolean(addressCountryToForm.template));
};
//# sourceMappingURL=fetch-address-forms.js.map